import script from "./NumberInsert.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberInsert.vue?vue&type=script&setup=true&lang=js"

import "./NumberInsert.vue?vue&type=style&index=0&id=1808a167&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1808a167"]])

export default __exports__